<template>
	<nav v-bind:class="[
			overviewActive ? 'overview-active': '',
			iActive ? 'i-active': ''
		]">
		<div id="icon-menu" class="icon icon-container">
			<router-link v-bind:to="{ name: 'Navigation'}">
				<span></span>
			</router-link>
		</div>
		<ul class="icon-container">
			<li id="icon-home" class="icon">
				<router-link v-bind:to="'/title-screen/1'">
					<span></span>
				</router-link>
			</li>
			<li id="icon-pi" class="icon">
				<a target="_blank" href="https://www.rxabbvie.com/pdf/venclexta.pdf">
					<span></span>
				</a>
			</li>
			<li id="icon-si" class="icon">
				<a v-on:click="openSI(si)">
					<span v-bind:class="openSIclass ? 'active' : ''"></span>
				</a>
			</li>
			<li id="icon-i" class="icon">
				<a v-on:click="toggleI(si)">
					<span v-bind:class="toggleIclass ? 'active' : ''"></span>
				</a>
				<div id="i-ref" v-if="toggleIclass">
					<img width="677" v-bind:src="require(`@/assets/aml-cll/ref-${si}.png`)" />
				</div>
			</li>
		</ul>
	</nav>
	<teleport to="body">
		<OverviewScreens
			v-if="overviewActive"
			v-bind:which="whichSI"
			v-on:close-overview="closeSI"
		/>
	</teleport>
</template>
<script>
import OverviewScreens from '@/components/OverviewScreens'
export default {
	props: {
		si: {
			type: String
		}
	},
	components: {
		OverviewScreens
	},
	data() {
		return {
			whichSI: this.si || null, 
			openSIclass: false,
			toggleIclass: false,
			overviewActive: false,
			iActive: false
		}
	},
	methods: {
		openSI(){
			this.overviewActive = true
			this.openSIclass = true
		},
		closeSI(){
			this.overviewActive = false
			this.openSIclass = false
		},
		toggleI(){
			this.toggleIclass = !this.toggleIclass
			this.iActive = !this.iActive
		}
	},
}
</script>

<style scoped>
nav {
	display: flex;
	justify-content: space-between;
	margin: 0 auto;
	position: fixed;
	top: 17px;
	right: 0;
	left: 0;
	width: 389px;
	height: 49px;
}

	nav.overview-active,
	nav.i-active {
		z-index: 1;
	}

	.icon-container {
		background-color: #f4f5f7;
		border-radius: 9px;
		min-width: 63px;
		height: 49px;
	}

		ul.icon-container {
			display: flex;
			justify-content: space-around;
			width: 319px;
		}

			ul.icon-container li:first-child {
				margin-left: 15px;
			}

			ul.icon-container li:last-child {
				margin-right: 18px;
			}

			.icon a {
				align-items: center;
				cursor: pointer;
				display: flex;
				justify-content: center;
				width: 100%;
				height: 100%;
			}

			.icon span {
				background-repeat: no-repeat;
				background-size: contain;
				display: block;
			}

				li.icon {
					width: 49px;
					height: 49px;
				}

				#icon-menu span {
					background-image: url(../assets/aml-cll/icon-menu.png);
					width: 24px;
					height: 10px;
				}

				#icon-home span {
					background-image: url(../assets/aml-cll/icon-home.png);
					width: 25px;
					height: 24px;
				}

				#icon-pi span,
				#icon-si span,
				#icon-i span {
					width: 24px;
					height: 24px;
				}

				#icon-pi span {
					background-image: url(../assets/aml-cll/icon-pi.png);
				}

				#icon-si span {
					background-image: url(../assets/aml-cll/icon-si.png);
				}

					#icon-si span.active {
						background-image: url(../assets/aml-cll/icon-si-active.png);
					}

			#icon-i {
				position: relative;
			}

				#icon-i span {
					background-image: url(../assets/aml-cll/icon-i.png);
				}

					#icon-i span.active {
						background-image: url(../assets/aml-cll/icon-i-active.png);
					}

				.icon.span {
					position: relative;
				}

				#i-ref {
					position: absolute;
					width: 667px;
					margin-top: 9px;
					transform: translateX( calc(-50% + 17px) );
					min-height: 211px;
					z-index: 1000000;
				}

				.icon span.active:after {
					background-color: #24b6a2;
					border-radius: 50%;
					bottom: 0;
					content: "";
					margin: 0 0 -3px 9px;
					position: absolute;
					width: 6px;
					height: 6px;
				}
</style>